import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const isPathwaysForAllEnabled = (makeImpression: boolean = false) => {
  if (typeof window === 'undefined' || !window.appName || window.appName !== 'consumer-home') {
    return false;
  }

  return makeImpression
    ? GrowthDiscoveryEpicClient.get('enablePathwaysForAll')
    : GrowthDiscoveryEpicClient.preview('enablePathwaysForAll');
};
